// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".borderedBlock[data-v-7da9b411]{border:1px solid rgba(0,0,0,.12)}.divideBorder[data-v-7da9b411]{background:rgba(0,0,0,.12);height:1px;width:100%}.curName[data-v-7da9b411]{color:#1f83f8;font-size:16px;line-height:28px}.curValue[data-v-7da9b411]{font-size:14px;line-height:28px}.curSource[data-v-7da9b411]{color:#878787;font-size:12px;line-height:28px}.green[data-v-7da9b411]{color:green}.red[data-v-7da9b411]{color:red}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
